<template>
  <div id="shopping-detail">
    <div class="wrap shopping-pro">
      <div class="wrap_zh">
        <div class="shopping-pro-img fl">
          <div class="shopping-pro-img_big fl" v-if="imgIndex == index" v-for="(img,index) in productDetails.productImgs" :key="index">
            <img :src="img.imgUrl">
          </div>
          <div class="shopping-pro-img_littile fr">
            <ul>
              <li :class="imgIndex == index && 'on'" v-for="(img,index) in productDetails.productImgs" :key="index" @mouseover="operaMouseImg(index)">
                <img :src="img.imgUrl">
              </li>
            </ul>
          </div>
        </div>
        <div class="shopping-pro-infos fr">
          <div class="shopping-pro-infos_title fl">
            <span>{{productDetails.productInfo.productName}}</span>
            <font>¥ {{productDetails.productInfo.price}}</font>
          </div>
          <div class="shopping-pro-infos_tag fl">
            <ul>
              <li v-for="(items,index) in productDetails.labels" :key="index">{{items.labelName}}</li>
            </ul>
          </div>
          <div class="shopping-pro-infos_stock fl">
            <span>库存</span>
            <font>{{productDetails.productInfo.stockNumber}}</font>
            <span>规格</span>
            <font>{{productDetails.productInfo.categoryCodeName}}</font>
            <span>分类</span>
            <font>{{productDetails.productInfo.categoryCodeName}}</font>
          </div>
          <div class="shopping-pro-infos_num fl">
            <div class="shopping-pro-infos_num-name fl">数量</div>
            <div class="shopping-pro-infos_num-compute fl">
              <el-input-number :min="1" label="数量" v-model="orderNum"></el-input-number>
            </div>
          </div>
          <div class="shopping-pro-infos_btn fl">
            <div class="shopping-pro-infos_btn-add fl" @click="operaAddShoppingCar">
              <img src="../../assets/images/shopping/home_icon_shoppingcart2.png">
              <span>加入购物车</span>
            </div>
            <div class="shopping-pro-infos_btn-buy fl" @click="operaSubmit">立即购买</div>
          </div>
        </div>
      </div>
    </div>
    <div class="wrap shopping-detail">
      <div class="wrap_zh">
        <div class="shopping-detail_title fl">
          <span></span>
          <font>商品介绍</font>
        </div>
        <div class="shopping-detail_info fl">
          <p>{{productDetails.productInfo.introduce}}</p>
        </div>
        <div class="shopping-detail_title shopping-detail_title-top fl" v-if="productDetails.productSub.length > 0">
          <span></span>
          <font>子产品</font>
        </div>
        <div class="shopping-detail_goods fl" v-if="productDetails.productSub.length > 0">
          <el-table
            :data="productDetails.productSub"
            :header-cell-style="{background:'#EFF1F5',fontSize:'14px',padding:'7px 0',textAlign:'center'}"
            style="width: 100%"
          >
            <el-table-column label="商品信息">
              <template slot-scope="scope">
                <div class="shopping-detail_goods-find">
                  <div class="shopping-detail_goods-find-img fl">
                    <img :src="scope.row.productImgUrl">
                  </div>
                  <dl>
                    <dt>{{scope.row.productName}}
                      <font>（{{scope.row.productSpec}}）</font>
                    </dt>
                    <dd>
                      <font
                            v-for="(s,n) in scope.row.productLabelList"
                            :key="s.id"
                            v-if="n < 3"
                          >{{s.labelName}}</font>
                    </dd>
                  </dl>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="单价" width="200">
              <template slot-scope="scope">
                <p class="shopping-cen">{{ scope.row.price }}</p>
              </template>
            </el-table-column>
            <el-table-column label="数量" width="200">
              <template slot-scope="scope">
                <p class="shopping-cen">{{ scope.row.address }}</p>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import { getProductDetailsByIdForTM, addProductCar } from "@/api";
import shoppingPublic from "@/assets/js/shoppingPublic";

export default {
  name: "shopping-detail",
  data() {
    return {
      productDetails: {
        labels: [],
        productImgs: [],
        productInfo: {},
        productSub: [],
        purchasePrices: [],
        warehouses: []
      },
      orderNum: 1,
      imgIndex: 0
    };
  },
  created() {
    this.operaGoodsDatils();
  },
  methods: {
    //获取货物详情
    operaGoodsDatils() {
      getProductDetailsByIdForTM({ id: this.$route.params.id }).then(res => {
        this.productDetails.labels = res.obj.labels;
        this.productDetails.productImgs = res.obj.productImgs;
        this.productDetails.productInfo = res.obj.productInfo;
        this.productDetails.productSub = res.obj.productSub;
        this.productDetails.purchasePrices = res.obj.purchasePrices;
        this.productDetails.warehouses = res.obj.warehouses;
        let imgLength = 6 - this.productDetails.productImgs.length;
        for(let i = 0; i < imgLength; i++){
          this.productDetails.productImgs.push({imgUrl:'../../../static/defalut.png'});
        }
        this.$store.commit('SEARCH_SHOPPING_GOODS','');
      });
    },
    //立即购买
    operaSubmit() {
      let submitArr = [];
      let obj = {};
      obj.price = this.productDetails.productInfo.price;
      obj.productId = this.productDetails.productInfo.id;
      obj.productImgUrl = this.productDetails.productImgs[0].imgUrl;
      obj.productLabels = this.productDetails.labels;
      obj.productName = this.productDetails.productInfo.productName;
      obj.productSpec = this.productDetails.productInfo.productSpec;
      obj.subtotal = this.productDetails.productInfo.price * this.orderNum;      
      obj.quantity = this.orderNum;
      submitArr.push(obj);
      sessionStorage.setItem("submitArr", JSON.stringify(submitArr));
      this.$router.push("/shoppingMall/shoppingSubmit");
    },
    //添加購物車
    operaAddShoppingCar() {
      let requestObj = {};
      requestObj.productId = this.productDetails.productInfo.id;
      requestObj.price = this.productDetails.productInfo.price;
      requestObj.quantity = this.orderNum;
      requestObj.subtotal = shoppingPublic.computePrice(this.productDetails.productInfo.price * this.orderNum, 2);
      requestObj.productSpec = this.productDetails.productInfo.productSpec;
      requestObj.systemType = this.$store.state.userInfo.brandId;
      requestObj.userId = this.$store.state.userInfo.staffId;
      addProductCar(requestObj).then(res => {
        if (res.code == 20001) {
          this.$emit("shoppingCars", "shoppingIndex");
        }
        this.$message({
          type: res.code == 20001 ? "success" : "error",
          message: res.msg
        });
      });
    },
    operaMouseImg(val){
      this.imgIndex = val;
    }
  }
};
</script>
<style type="text/css">
/* 商品展示 */
.shopping-pro {
  margin-top: 40px;
}
.shopping-pro-img {
  width: 470px;
}
.shopping-pro-img_big {
  width: 400px;
  height: 400px;
  line-height: 400px;
  text-align: center;
  background: #ffffff;
}
.shopping-pro-img_big img {
  max-width: 400px;
  max-height: 400px;
  vertical-align:0%;
}
.shopping-pro-img_littile {
  width: 60px;
  height: 400px;
  overflow: hidden;
}
.shopping-pro-img_littile ul {
  float: left;
  width: 60px;
  height: 408px;
}

.shopping-pro-img_littile ul li {
  float: left;
  margin-bottom: 8px;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  background: #ffffff;
  border: 2px solid #F5F7FA;
  cursor: pointer;
}
.shopping-pro-img_littile ul li img {
  max-width: 56px;
  max-height: 56px;
  vertical-align:0%;
}
.shopping-pro-img_littile ul li.on {
  border: 2px solid #f83c57;
}
.shopping-pro-infos {
  padding-left: 30px;
  padding-right: 30px;
  width: 710px;
  height: 400px;
  background: #ffffff;
}
.shopping-pro-infos_title {
  padding-left: 20px;
  padding-top: 44px;
  width: 100%;
  font-size: 24px;
}
.shopping-pro-infos_title span {
  color: #222222;
}
.shopping-pro-infos_title font {
  padding-left: 34px;
  color: #f83c57;
}
.shopping-pro-infos_tag {
  padding-left: 20px;
  padding-top: 29px;
  width: 100%;
}

.shopping-pro-infos_tag ul {
  float: left;
  width: 100%;
  height: 60px;
}

.shopping-pro-infos_tag ul li {
  float: left;
  margin-bottom: 10px;
  margin-right: 10px;
  padding: 0 12px 0 12px;
  line-height: 28px;
  font-size: 12px;
  color: #666666;
  border: 1px solid #cccccc;
  border-radius: 5px;
}
.shopping-pro-infos_stock {
  margin-top: 20px;
  width: 100%;
  height: 44px;
  line-height: 44px;
  background: #f6f7f9;
}
.shopping-pro-infos_stock {
  font-size: 14px;
}
.shopping-pro-infos_stock span {
  padding-left: 20px;
  color: #666666;
}
.shopping-pro-infos_stock font {
  padding-right: 26px;
  padding-left: 10px;
  color: #222222;
}
.shopping-pro-infos_num {
  padding-top: 17px;
  width: 100%;
}
.shopping-pro-infos_num-name {
  padding-left: 20px;
  line-height: 40px;
  font-size: 14px;
  color: #666666;
}
.shopping-pro-infos_num-compute {
  padding-left: 10px;
}
.shopping-pro-infos_num-compute .el-input-number {
  width: 123px;
  height: 38px;
  line-height: 36px;
}
.shopping-pro-infos_num-compute .el-input-number__decrease,
.shopping-pro-infos_num-compute .el-input-number__increase,
.shopping-pro-infos_num-compute .el-input__inner {
  border-radius: 0;
}
.shopping-pro-infos_num-compute .el-input-number__decrease,
.shopping-pro-infos_num-compute .el-input-number__increase {
  width: 30px;
  background: #ffffff;
}
.shopping-pro-infos_num-compute .el-input__inner {
  height: 38px;
}
.shopping-pro-infos_btn {
  padding-top: 32px;
}
.shopping-pro-infos_btn-add {
  margin-left: 20px;
  width: 180px;
  height: 48px;
  background: #2ecfa7;
  color: #ffffff;
  font-size: 16px;
  text-align: center;
  line-height: 48px;
  border-radius: 5px;
  cursor: pointer;
}
.shopping-pro-infos_btn-buy {
  margin-left: 14px;
  width: 140px;
  height: 48px;
  background: #f83c57;
  color: #ffffff;
  font-size: 16px;
  text-align: center;
  line-height: 48px;
  border-radius: 5px;
  cursor: pointer;
}

/*商品描述详情*/
.shopping-detail {
  margin-top: 40px;
  margin-bottom: 40px;
}
.shopping-detail .wrap_zh {
  padding: 60px 60px 80px 60px;
  box-sizing: border-box;
  background: #ffffff;
}
.shopping-detail_title {
  width: 100%;
}
.shopping-detail_title span {
  float: left;
  margin-top: 3px;
  margin-right: 10px;
  width: 6px;
  height: 18px;
  background: #f83c57;
  border-radius: 3px;
}
.shopping-detail_title font {
  float: left;
  font-size: 16px;
  color: #444444;
}
.shopping-detail_title-top {
  padding-top: 43px;
}
.shopping-detail_info {
  padding-top: 33px;
}
.shopping-detail_info p {
  text-indent: 2em;
  line-height: 36px;
  font-size: 14px;
  color: #444444;
}
</style>


// WEBPACK FOOTER //
// src/components/shoppingMall/shoppingDetail.vue